export default "__VITE_ASSET__8H8ogOw4__"